import React from 'react';
import { useBrsCreateStyles } from '../BrsCreateStyles';

export const HybridModeBanner = ({ spots }) => {
  const classes = useBrsCreateStyles();

  if (!spots || spots.length < 2) return null;

  // BRS-FORM-P1 smart form: a spot is "existing" (traffic-only update)
  // if Cadent has it — represented by either the authoritative
  // `traffic_only` flag from the smart-form lookup, or the legacy
  // `isciasset.exists` flag from the DH-side lookup. We treat either as
  // a signal so the banner shows for pre-populated rows too.
  const isExistingSpot = (s) => s.traffic_only === true || s.isciasset?.exists === true;
  const isNewSpot = (s) => s.traffic_only !== true && s.isciasset?.exists === false;

  const hasExisting = spots.some(isExistingSpot);
  const hasNew = spots.some(isNewSpot);

  if (!hasNew || !hasExisting) return null;

  return (
    <div className={classes.hybridBanner}>
      <span style={{ fontSize: 16 }}>&#9432;</span>
      <span>
        <strong>Hybrid job detected.</strong> This job contains both new and existing ISCIs. New spots will go through
        full media delivery; existing spots will generate a traffic-only update.
      </span>
    </div>
  );
};
